// extracted by mini-css-extract-plugin
export default {"pageContent":"Contact_pageContent__8gq81","contactCard":"Contact_contactCard__YhXDw","contactCardText":"Contact_contactCardText__ammui","contactsList":"Contact_contactsList__3QN8T"};